import { render, staticRenderFns } from "./downgrade.vue?vue&type=template&id=30a0b6e6&scoped=true"
import script from "./downgrade.vue?vue&type=script&lang=js"
export * from "./downgrade.vue?vue&type=script&lang=js"
import style0 from "./downgrade.vue?vue&type=style&index=0&id=30a0b6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0b6e6",
  null
  
)

export default component.exports